// RC9

// Remove unnecessary information at the start of the title to match the actual variant title
function parseTitleData(title) {
    // console.log(`parseTitleData called with title: `, title);

    if (title === null || title === undefined) return "";

    // Remove everything before and including " / "
    return title.includes(" / ") ? title.split(" / ").pop().trim() : title.trim();
}


// Handles changing the product on carousel's
function changeActiveProductCarousel(title, variantId) {
    // console.log(`Changing the active product to ${variantId} (title=${title}, variantId=${variantId})`);

    if (!window.product?.variants) {
        console.error(`Window does not contain any product variants!`);
        return;
    }

    if (variantId == null) {
        console.error(`Variant ID is null!`);
        return;
    }

    let dropdown = $(`#product-select-${window.product.id}-option-1`);
    if (dropdown.length <= 0) {
        // console.log('Using option 0');
        dropdown = $(`#product-select-${window.product.id}-option-0`);
    } else {
        // console.log('Using option 1');
    }

    title = parseTitleData(title)

    let matchingOption = dropdown.find(`option[value="${title}"]`);
    // console.log('Match pattern: ', matchingOption);

    if (matchingOption.length > 0) {
        dropdown.val(matchingOption.val());
        setTimeout(() => {
            dropdown.trigger("change");
            // updateProductGalleryCarousel(variantId);     // obsolete
        }, 25);
    } else {
        console.log(`No matching option found for variantId: ${variantId}`, matchingOption);
    }
}


function changeActiveProduct(variantId) {
    // console.log(`Changing the active product to ${variantId}`);

    if (!window.product?.variants) return;

    if (variantId == null) return;

    let dropdown = $(`#product-select-${window.product.id}-option-1`);
    if (dropdown.length <= 0) {
        // console.log('Using option 0');
        dropdown = $(`#product-select-${window.product.id}-option-0`);
    } else {
        // console.log('Using option 1');
    }
    let matchingOption = dropdown.find(`option[data-variant-id="${variantId}"]`);

    if (matchingOption.length > 0) {
        dropdown.val(matchingOption.val());
        setTimeout(() => {
            dropdown.trigger("change");
            updateProductGallery(variantId);
        }, 50);
    } else {
        console.log(`No matching option found for variantId: ${variantId}`);
    }
}

/// * Converts an image URL to the specified Shopify size */
function convertImageToShopSize(imgUrl, size) {
    // console.log("Converting", imgUrl, "to", size);

    if (typeof imgUrl !== "string") {
        console.error("convertImageToShopSize error: imgUrl is not a string!", imgUrl);
        return imgUrl;
    }

    // Remove existing Shopify size suffixes (_WxH or _grande_WxH)
    imgUrl = imgUrl.replaceAll(/(_grande)?_\d{2,4}x\d{2,4}/g, "");

    // Define allowed Shopify image sizes
    const allowedSizes = ["small", "compact", "medium", "large", "grande", "1024x1024", "2048x2048"];

    // Default to "grande" if the provided size is invalid
    if (!allowedSizes.includes(size)) {
        console.warn(`Invalid size: ${size}. Defaulting to "grande".`);
        size = "grande";
    }

    // Replace existing extension with Shopify size
    return imgUrl.replace(/\.(jpg|jpeg|png|gif)/, `_${size}.$1`);
}

/// * Updates the active image */
function changeActiveImageCarousel(newSrc, eventData = null, imgData = null) {
    // newSrc = convertImageToShopSize(newSrc, "grande");
    // console.log("New source:", newSrc);

    let featuredImageElement = $(".featured_image");
    if (featuredImageElement.length) {
        featuredImageElement.attr({src: newSrc, "data-src": newSrc});
    } else {
        console.error("No element found with class 'featured_image'");
    }
}

/// * Updates the active image (grid) */
function changeActiveImage(newSrc, eventData = null, imgData = null) {
    // newSrc = convertImageToShopSize(newSrc, "grande");
    // console.log("New source:", newSrc, "Event data:", eventData);

    let featuredImageElement = $(".featured_image");
    if (featuredImageElement.length) {
        featuredImageElement.attr({src: newSrc, "data-src": newSrc});
    } else {
        console.error("No element found with class 'featured_image'");
    }

    let imageSlide = $(".image-slide-link");
    var newSource = $('.featured_image').attr("src");

    // console.log('The new source is ', newSource);

    if (imageSlide.length) {
        imageSlide.attr("href", newSource);
    } else {
        console.error("No element found with class 'image-slide-link'");
    }
}

/// * Updates the product gallery based on the selected variant. */
function updateProductGalleryCarousel(variantId) {
    // console.log("Updating gallery for variant:", variantId);
    let variant = findVariantById(variantId);

    if (!variant) {
        console.log("Variant not found.");
        return;
    }

    // variant.featured_image.src = convertImageToShopSize(variant.featured_image.src, "grande");
    // console.log("Variant found:", variant);

    let featuredImageElement = $(".featured_image");
    if (featuredImageElement.length) {
        // console.log("Shopify switchImage called");
        // $('.featured_image').attr("data-src", variant.featured_image.src);
        // console.log(`Changing featured image source to ${variant.featured_image.src}`);
        // console.log(`There are ${$('.featured_image').length} featured images`);
    } else {
        console.error("No element found with class 'featured_image'");
    }

}


/// * Updates the product gallery based on the selected variant. */
function updateProductGallery(variantId) {
    // console.log("Updating gallery for variant:", variantId);
    let variant = findVariantById(variantId);

    if (!variant) {
        console.warn("Variant not found.");
        return;
    }

    variant.featured_image.src = convertImageToShopSize(variant.featured_image.src, "grande");
    // console.log("Variant found:", variant);

    let featuredImageElement = $(".featured_image");
    if (featuredImageElement.length) {
        // console.log("Shopify switchImage called");
        $('.featured_image').attr("data-src", variant.featured_image.src);
    } else {
        console.error("No element found with class 'featured_image'");
    }

    let imageSlide = $(".image-slide-link");
    var newSource = $('.featured_image').attr("src");
    // console.log('The new source is ', newSource);
    if (imageSlide.length) {
        imageSlide.attr("href", newSource);
    } else {
        console.error("No element found with class 'image-slide-link'");
    }
}

/// * Finds a variant by its ID. */
function findVariantById(variantId) {
    if (!window.product?.variants) {
        console.error("Product or variants not found in window object.");
        return null;
    }

    return window.product.variants.find(variant => variant.id.toString() === variantId.toString()) || null;
}
